import React, { Component } from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import PropTypes from "prop-types";
// internal imports
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { ASSET } from "../../../../constants";

// action imports
import { updateAssetSearchContentAction } from "../../../../actions/AssetActions/assetActions";

// destructuring
const { ASSET_PAGE_URL, ASSET_ITEM_TYPES } = ASSET;

class SearchDropdown extends Component {
  state = {};

  componentDidMount() {
    // add close event listner
    document.addEventListener("click", this.handleClickOutside);
  }

  componentWillUnmount() {
    document.removeEventListener("click", this.handleClickOutside);
  }

  setWrapperRef = node => {
    this.wrapperRef = node;
  };

  _getAssetFolderUrl = (
    docNo,
    folderId,
    folderName,
    folderType,
    opportunityId,
    opportunityRoot,
  ) => {
    // Check, If the current item is a "Folder" or Not
    let isFolder = false;
    if (folderType === ASSET_ITEM_TYPES.FOLDER) {
      isFolder = true;
    }
    let url = "";
    if (isFolder) {
      url = `/${ASSET_PAGE_URL}/${folderName
        .toLocaleLowerCase()
        .split(" ")
        .join("-")}/${folderId}`;

      if (opportunityRoot && opportunityId) {
        url = `${url}/?opp_id=${opportunityId}`;
      }
    } else {
      url = `/documents/${docNo}`;
    }
    return url;
  };

  handleClickOutside = event => {
    if (
      this.wrapperRef &&
      !this.wrapperRef.contains(event.target) &&
      event.target.dataset.id !== "asset-search"
    ) {
      this.props.toggleDropdown(false);
    }
  };

  getSearchResults = () => {
    const {
      updateAssetSearchContentAction: updateAssetSearchContent,
      toggleSearchPage,
      toggleDropdown,
      searchTerm,
    } = this.props;
    if (searchTerm.trim()) {
      updateAssetSearchContent(searchTerm)
        .then(() => {
          toggleSearchPage(true);
          toggleDropdown(false);
        })
        .catch(err => {
          console.debug(err);
        });
    }
  };

  render() {
    const {
      assetSearchSuggestions,
      showDropdown,
      searchTerm,
      filePointer,
      folderPointer,
    } = this.props;

    let fileSuggestions = null;
    if (
      assetSearchSuggestions &&
      assetSearchSuggestions.files &&
      assetSearchSuggestions.files.length
    ) {
      fileSuggestions = assetSearchSuggestions.files;
    }

    let folderSuggestions = null;
    if (
      assetSearchSuggestions &&
      assetSearchSuggestions.folders &&
      assetSearchSuggestions.folders.length
    ) {
      folderSuggestions = assetSearchSuggestions.folders;
    }

    let show = showDropdown;
    if (fileSuggestions || folderSuggestions) {
      show = show && true;
    }
    return (
      <div
        ref={this.setWrapperRef}
        className={`assetheader-search-dropdown ${
          show ? "show-dropdown" : ""
        }`}>
        {/* Search for */}
        <div
          onClick={this.getSearchResults}
          tabIndex="0"
          role="button"
          onKeyDown={() => {}}
          className="assetheader-search-for">
          <FontAwesomeIcon
            icon={["far", "search"]}
            className="assetheader-search-for-icon"
          />
          Search for &quot;{searchTerm}&quot;
        </div>

        {/* Files List */}

        {fileSuggestions &&
          fileSuggestions.map((item, i) => (
            <Link
              onClick={() => this.props.toggleDropdown(false)}
              className="assetheader-search-dropdown-item-name"
              to={this._getAssetFolderUrl(
                item.doc_no,
                item.id,
                item.name,
                item.type,
                item.opportunity_id,
                item.opportunity_root,
              )}>
              <div
                key={`${item.id}-asset-file-suggestion`}
                className={`assetheader-search-dropdown-item ${
                  filePointer === i ? "activate-search-item" : null
                }`}>
                <FontAwesomeIcon
                  icon={["fal", "file-alt"]}
                  className="assetheader-search-file-icon file extquote-file-icon "
                />

                {item.name}
                <span className="assetheader-search-dropdown-item-by-label">
                  created by
                </span>
                <span className="assetheader-search-dropdown-item-by">
                  {item.owner && item.owner.name}
                </span>
              </div>
            </Link>
          ))}

        {folderSuggestions ? (
          <div className="asset-search-suggestion-type-border" />
        ) : null}

        {/* Folders List */}
        {folderSuggestions &&
          folderSuggestions.map((item, i) => (
            <div
              key={`${item.id}-asset-file-suggestion`}
              className={`assetheader-search-dropdown-item ${
                folderPointer === i ? "activate-search-item" : null
              }`}>
              <FontAwesomeIcon
                icon={["fas", "folder"]}
                className="assetheader-search-file-icon file extquote-file-icon "
              />

              <Link
                onClick={() => this.props.toggleDropdown(false)}
                className="assetheader-search-dropdown-item-name"
                to={this._getAssetFolderUrl(
                  item.doc_no,
                  item.id,
                  item.name,
                  item.type,
                  item.opportunity_id,
                  item.opportunity_root,
                )}>
                {item.name}
              </Link>
              <span className="assetheader-search-dropdown-item-by-label">
                folder
              </span>
            </div>
          ))}
      </div>
    );
  }
}

SearchDropdown.propTypes = {
  searchTerm: PropTypes.string.isRequired,
  toggleSearchPage: PropTypes.func.isRequired,
  updateAssetSearchContentAction: PropTypes.func.isRequired,
};

const mapStateToProps = ({ AssetStore: { assetSearchSuggestions = {} } }) => ({
  assetSearchSuggestions,
});

const mapDispatchToProps = {
  updateAssetSearchContentAction,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(SearchDropdown);



// WEBPACK FOOTER //
// ./src/components/AssetWrapper/AssetHeader/AssetHeaderSearch/SearchDropdown.js